import {Component, OnInit} from '@angular/core';
import {Subject} from 'rxjs/Subject';
import {BsModalRef} from 'ngx-bootstrap';
import {Router} from '@angular/router';
import {HttpClient} from '@angular/common/http';
import {UtentiService} from '../../utenti/utenti.service';
import {AuthServerProvider} from '../auth/auth-jwt.service';
import {AccountService} from '../auth/account.service';
// import {ContabilitaService} from '../contabilita.service';


@Component({
  selector: 'app-passaggio-modal',
  templateUrl: './passaggio-modal.component.html',
  styleUrls: ['./passaggio-modal.component.scss']
})

export class PassaggioModalComponent implements OnInit {

  closeBtnName: string;
  public onClose: Subject<any>;

  readonly;

  constructor(
    private router: Router,
    private http: HttpClient,
    public bsModalRef: BsModalRef,
    private accountService: AccountService,
    private authServerProvider: AuthServerProvider
  ) {
    this.onClose = new Subject();
  }

  ngOnInit() {
    // this.http.get('https://pastebin.com/raw/hpcsG8aj').subscribe((res: any) => {
    //   console.log(res.text());
    // });
  }

  accept() {
    this.accountService.acceptPrivacy().subscribe((res) => {
      this.onClose.next(true);
      this.bsModalRef.hide();
    })
  }

  deny() {
    this.authServerProvider.logout().subscribe(() => {
      this.router.navigate(['/login']);
    });
    this.bsModalRef.hide();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/passaggio-modal/passaggio-modal.component.ts